export const CAMBIAR_ESTADO_DATOS_CARGADOS =
  "[DASHBOARD-MAIN] GUARDA LISTA DE TODOS LOS EVENTOS PARA EL BUSCADOR";
export function cambiarEstadoDatosCargados(nuevoEstado) {
  return (dispatch) => {
    dispatch({ type: CAMBIAR_ESTADO_DATOS_CARGADOS, payload: nuevoEstado });
  };
}
